import { Handler } from "../chain/TransformServiceHandlerChain";
import { CustomApiTransformUtil } from "../util/CustomApiTransformUtil";
import { tryPromise } from "../../../../cutil/LangUtil";
import { CustomApiTransformError } from "../error/CustomApiTransformError";
export class UrlHandler extends Handler {
    constructor(brainClient) {
        super();
        this.brainClient = brainClient;
    }
    async process(request) {
        /// 只处理带有 'X-Brain-Imagica-Node' 的数据
        if (!request.hasNodeDisplayType) {
            return false;
        }
        /// 只处理 upload file type数据
        if (!CustomApiTransformUtil.isUploadFileType(request.displayType)) {
            return false;
        }
        const result = await tryPromise(request.json());
        if (!result.data) {
            throw CustomApiTransformError.default;
        }
        const json = result.data;
        const url = json.s3_url || json.url;
        /// 如果没有返回 url，不执行后续逻辑
        if (!url && typeof url !== "string") {
            return false;
        }
        let method = "get";
        if (typeof json.method === "string") {
            method = json.method;
        }
        let body = undefined;
        if (typeof json.body === "string") {
            body = json.body;
        }
        const headers = json.headers;
        const res = await tryPromise(this.brainClient.global.request(url, method, headers, body));
        /// 更新 response 继续处理后续内容
        request.updateResponse(res.data);
        return false;
    }
}
